import { useEffect, useRef } from "react";

export const Starfield = ({ density = 0.00012 }) => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let stars = [];
    let raf;
    let w = 0;
    let h = 0;

    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.offsetWidth;
      h = canvas.offsetHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      stars = Array.from({ length: Math.round(w * h * density) + 40 }, () => ({
        x: Math.random() * w,
        y: Math.random() * h,
        r: Math.random() * 1.2 + 0.2,
        s: Math.random() * 0.12 + 0.02,
        p: Math.random() * Math.PI * 2,
        gold: Math.random() < 0.3,
      }));
    };

    const draw = (t) => {
      ctx.clearRect(0, 0, w, h);
      for (const st of stars) {
        if (!reduce) {
          st.y -= st.s;
          st.x += st.s * 0.35;
          if (st.y < -2) st.y = h + 2;
          if (st.x > w + 2) st.x = -2;
        }
        const a = 0.35 + 0.55 * Math.abs(Math.sin(t * 0.0006 + st.p));
        ctx.beginPath();
        ctx.arc(st.x, st.y, st.r, 0, Math.PI * 2);
        ctx.fillStyle = st.gold ? `rgba(214,190,130,${a})` : `rgba(250,246,237,${a * 0.8})`;
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    };

    resize();
    raf = requestAnimationFrame(draw);
    window.addEventListener("resize", resize);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, [density]);

  return <canvas ref={ref} className="absolute inset-0 w-full h-full pointer-events-none" aria-hidden="true" />;
};
